// extracted by mini-css-extract-plugin
export default {"svgIcon":"rbITVEGp"};